import { DateTime } from 'luxon';
import { TaskV2 } from '../../types';
import DueColumn from '../DueColumn/DueColumn';

export const taskLink = (eventId: number, id: number) => `/quality-events/events/${eventId}?task_id=${id}`;

export const renderDueAtDueColumn = (task: TaskV2) => {
  const closedAt = task.attributes.closed_at ? DateTime.fromSeconds(task.attributes.closed_at) : undefined;
  const dueAt = DateTime.fromSeconds(task.attributes.due_at, { zone: 'utc' }).endOf('day');

  return (
    <DueColumn
      dueAt={dueAt}
      isInFinalStatuses={['closed_success', 'closed_fail'].includes(task.attributes.status)}
      closedAtDatetime={closedAt}
    />
  );
};
